import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'
import { adminMcpOAuthClientsQueryOptions } from '@/lib/queries/admin'
import {
  AdminOAuthClientsDialogs,
  AdminOAuthClientsList,
  AdminOAuthClientsPrimaryButtons,
  AdminOAuthClientsProvider,
} from '@/features/admin'

export const Route = createFileRoute('/_authenticated/admin/oauth-clients')({
  loader: ({ context }) => {
    context.queryClient.query({
      ...adminMcpOAuthClientsQueryOptions(),
      staleTime: 'static',
    })
  },
  component: AdminOAuthClientsPage,
})

function AdminOAuthClientsPage() {
  const { data: clients } = useSuspenseQuery(adminMcpOAuthClientsQueryOptions())

  return (
    <AdminOAuthClientsProvider>
      <div className='w-full space-y-4'>
        <div className='flex items-center justify-between'>
          <div>
            <h2 className='font-heading text-xl'>OAuth Clients</h2>
            <p className='text-muted-foreground text-sm'>
              Pre-registered OAuth apps for MCP servers that don&apos;t speak
              Dynamic Client Registration. Modern servers (Notion, Linear)
              don&apos;t need rows here — iris handles them automatically.
            </p>
          </div>
          <AdminOAuthClientsPrimaryButtons />
        </div>

        <AdminOAuthClientsList data={clients} />
      </div>

      <AdminOAuthClientsDialogs />
    </AdminOAuthClientsProvider>
  )
}
